import type { BadgeVariant } from '@/components/ui/badge';
import type { ReservationStatus } from '@/lib/booking/types';

// Single source for reservation-status → Badge tone, shared by the allocation
// surfaces (the roster PNR drawer, the reservations panel, and the reusable
// allocation component family). Previously duplicated inline in
// roster-pnr-drawer.tsx and reservations-panel.tsx — see
// docs/ui/reusable-allocation-components.plan.md (PR1).

/**
 * Tone for a reservation status badge — BOOKED is settled (success), HELD is the
 * reversible offer awaiting acceptance (secondary), PENDING is in-flight (warning), FAILED / CANCEL_FAILED are error, CANCELLED is muted.
 */
export const RESERVATION_STATUS_TONE: Record<ReservationStatus, BadgeVariant> = {
  BOOKED: 'success',
  HELD: 'secondary',
  PENDING: 'warning',
  FAILED: 'error',
  CANCELLED: 'muted',
  CANCEL_FAILED: 'error',
};
